import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    opened: {
      color: "green",
      borderColor: "green"
    },
    closed: {
      color: "red",
      borderColor: "red"
    },
    inSetup: {
      color: "orange",
      borderColor: "orange"
    },
    menuButtonActive: {
      color: "white",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.2) !important"
    },
    menuButton: {
      color: "white",
      display: "flex",
      alignItems: "center"
    },
    icon: {
      marginRight: "8px",
      fontSize: "1.5rem",
      "@media (max-width:600px)": {
        marginRight: "4px",
        fontSize: "1rem"
      }
    },
    text: {
      fontWeight: 500,
      fontSize: "1rem",
      "@media (max-width:600px)": {
        fontSize: "0.85rem"
      }
    },
    eventDetailTableContainer: {
      [theme.breakpoints.down("md")]: {
        justifyContent: "center"
      },
      [theme.breakpoints.up("lg")]: {
        justifyContent: "end"
      }
    },
    eventDetailTable: {
      "& th": {
        color: theme.palette.grey[800]
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        "& th": {
          width: "auto"
        }
      },
      [theme.breakpoints.up("lg")]: {
        width: "90%",
        "& th": {
          width: "25%"
        }
      }
    },
    inventoryProcessedButton: {
      animation: "$wiggle .1s 25 alternate"
    },
    "@keyframes wiggle": {
      "0%": { transform: "rotate(-5deg)" },
      "100%": { transform: "rotate(5deg)" }
    },
    dialogHeader: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      padding: theme.spacing(2)
    },
    receiptIcon: {
      marginRight: theme.spacing(1)
    },
    datePickerWrapper: {
      flex: "1 1 auto",
      minWidth: "200px",
      maxWidth: "100%",
      marginTop: theme.spacing(1),
      [theme.breakpoints.up("sm")]: {
        marginTop: 0
      }
    },
    inputField: {
      marginBottom: theme.spacing(2)
    },
    label: {
      fontWeight: 500,
      marginBottom: theme.spacing(1)
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(2),
      flexDirection: "column"
    },
    approveButton: {
      textTransform: "none",
      fontWeight: 500,
      padding: theme.spacing(1.5, 4),
      backgroundColor: theme.palette.primary.main,
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark
      }
    },
    saveReportAnywayButton: {
      textTransform: "none",
      fontWeight: 500,
      padding: theme.spacing(1.5, 4),
      backgroundColor: theme.palette.error.main,
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.error.dark
      }
    },
    approveButtonDisabled: {
      textTransform: "none",
      fontWeight: 500,
      padding: theme.spacing(1.5, 4),
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.text.disabled,
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: theme.palette.grey[400]
      }
    },

    errorMessage: {
      color: theme.palette.error.main,
      fontSize: "0.875rem",
      marginTop: theme.spacing(1),
      textAlign: "center"
    },
    tableWrapper: {
      padding: "0",
      margin: "0",
      "& .MuiPaper-outlined": {
        border: 0
      },
      "& .MuiTable-root": {
        "& .MuiTableRow-root": {
          height: "36px",
          "& .MuiTableCell-root": {
            paddingTop: "4px",
            paddingBottom: "4px",
            "& .MuiTableSortLabel-root": {
              "&:hover": {
                color: "#bbdefb"
              }
            },
            "& .MuiTableSortLabel-active": {
              color: "#bbdefb",
              "& .MuiTableSortLabel-icon": {
                color: "#bbdefb"
              }
            }
          }
        }
      }
    },
    smallTextButton: {
      fontSize: "0.75rem",
      padding: "4px 8px",
      minWidth: "auto"
    },
    detailTable: {
      padding: 20,

      backgroundColor: theme.palette.grey[200]
    },
    summaryContainer: {
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.divider}`
    },
    summaryTitle: {
      fontWeight: 500,
      marginBottom: theme.spacing(1),
      color: theme.palette.primary.main
    },
    summaryItem: {
      display: "flex",
      justifyContent: "space-between",
      padding: theme.spacing(0.5, 0)
    },
    summaryAmount: {
      fontWeight: 500
    },
    summaryTotal: {
      display: "flex",
      justifyContent: "space-between",
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(1),
      fontWeight: "bold"
    }
  })
);
